import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import setRem from '@/utils/setRem'
import '@/locales'
import '@/styles/global.less'
import '@/styles/class.less'

// rem 自适应：在 React 渲染前设置 html font-size，避免 FOUC
setRem()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
